<template>

  <div>
    <div v-bind:class="get_container_class()" v-if="!entry.stars">
      <div class="hit-alert hit-alert-danger">{{ $tc("message.noEntry", 1) }}</div>
    </div>

    <div v-bind:class="get_container_class()" v-if="entry.stars">

      <div class="hit-panel hit-panel-success">

        <div class="hit-panel-heading">
          {{ $tc("message.feedback", 1) }} <b>{{ entry.name }}</b>
        </div>
        <div class="hit-panel-body hit-text-center">
            <feedback_vote :entry="entry" :settings="{container: 'warning'}"/>
        </div>

        <div class="hit-panel-heading" v-if="!settings || !settings.no_delete">
          @{{ entry.name }}
        </div>

        <div class="hit-panel-body hit-text-center" v-if="!settings || !settings.no_delete">

            {{ get_target_page_text() }}

        </div>

        <div class="hit-panel-heading" v-if="!settings || !settings.no_delete">
          {{ $tc("message.settings", 2) }}</b>
        </div>
        <div class="hit-panel-body hit-text-center" v-if="!settings || !settings.no_delete">

            <h4 class="hit-html-h4">
              {{ $tc("message.feedback", 1) }}: {{ entry.name }}<hit_delete class="hit-html-html hit-text-danger" :callback="function(){ get_delete(); }">{{ $t("message.allDataWillBeDeleted") }}</hit_delete>
            </h4>

        </div>

        <div class="hit-panel-heading">
          {{ $tc("message.feedback", 2) }} <b>{{ entry.board.name }}</b>
        </div>
        <div class="hit-panel-body ">

          <div class="hit-row">

            <div class="hit-col-md-3">
              <div class="hit-form-group hit-text-center">
                <hit_badge v-if="landingpage" :survey="landingpage" :design="'Alphonso'"/>
              </div>
            </div>

            <div class="hit-col-md-9">

              <div class="hit-form-group">
                <hit_votes v-if="landingpage" :survey="landingpage" :design="'Table'"/>
              </div>
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>

</template>

<script>

import feedback_vote from '@core/components/content/app/feedback/feedback_vote'

export default{
  components: { feedback_vote },
  props: {data: Object, settings: Object},
  data () {
    return {
      user: false,
      board: false,
      ID: false,
      entry: false,
      landingpage: false
    }
  },

  methods: {

    get_target_page_text () {
      var avg = Math.round(this.entry.average)

      var r = this.$nl2br(this.$t('demo.targetText', {star: avg}))

      try {
        if (typeof this.$store.getters.target_pages[this.entry.board][avg] !== 'undefined') { r = this.$store.getters.target_pages[this.entry.board][avg] }
      } catch (err) { };

      return r
    },
    get_delete () {
      var send = {
        user: this.user,
        board: this.board,
        ID: this.ID
      }

      var my_class = this

      this.$hit_post({url: 'hitclick/votes/delete',
        data: send,
        callback: function (ret) {
          my_class.entry = false
        }})
    },
    get_container_class () {
      if (typeof this.settings !== 'object') { return 'hit-container' }

      if (typeof this.settings.no_container !== 'boolean' || this.settings.no_container != true) { return 'hit-container' }
    },
    get_entry () {
      var my_class = this

      if (typeof this.user === 'undefined') { return false }

      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: this.user, board: this.board, ID: this.ID},
        callback: function (ret) {
          if (ret.data[0]) {
            my_class.entry = ret.data[1]
            my_class.get_all()
          }
        }})
    },

    get_all () {
      var my_class = this

      this.$hit_post({url: 'hitclick/landingpage/get',
        data: {username: this.entry.board.user.username, board: this.entry.board.ID},
        callback: function (ret) {
          if (!ret.data[0]) { return false }

          my_class.landingpage = ret.data[1]

          my_class.landingpage.feedback.forEach(function (data, index) {
            my_class.landingpage.feedback[index].board = my_class.entry.board.ID
            my_class.landingpage.feedback[index].time = my_class.landingpage.feedback[index].date
          })

          my_class.$store.commit('set_votes', ret.data[1].feedback)
        }})
    }
  },

  mounted () {
    this.user = this.$route.params.userID

    if (typeof this.data !== 'undefined' && typeof this.data.user !== 'undefined') { this.user = this.data.user }

    this.board = this.$route.params.boardID

    if (typeof this.data !== 'undefined' && typeof this.data.board !== 'undefined') { this.board = this.data.board }

    this.ID = this.$route.params.entryID

    if (typeof this.data !== 'undefined' && typeof this.data.ID !== 'undefined') { this.ID = this.data.ID }

    this.get_entry()
  }
}

</script>
